import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentStep: 1,
};

const otpSlice = createSlice({
    name: 'otp',
    initialState,
    reducers: {
        reset: () => initialState,

        otpReportStep: {
            reducer(state, action) {
                state.currentStep = action.payload;
            },
        },

    },
});

export const { otpReportStep } = otpSlice.actions;
export default otpSlice.reducer;
